<script setup>
import {ref, nextTick} from "vue"
import helpers from "@/lib/helpers";

const props = defineProps({
  package: Object
})

const label_file = ref()
const emits = defineEmits(['input'])

const change = async (event) => {
  if (event === null) {
    emits('input', '')
  } else {
    const file = event.target.files[0]

    if (!file)
      return

    const reader = new FileReader();
    reader.readAsDataURL(file)
    reader.onload = async () => {
      emits('input', reader.result)
    };

    reader.onerror = (error) => {
      helpers.alert('Error: ' + error)
      label_file.value = null
    };
  }
}

const carrier_label_preview = (url) => {
  window.open(url, '_blank')
}

</script>

<template>
  <div>
    <b-btn-group class="w-100 my-2" v-if="package && package.label_type === 'PDF' && package.has_label">
      <b-btn @click="carrier_label_preview(package._links.carrier_label_preview_url.href)" block size="sm"
             variant="outline-secondary">
        Label PDF
      </b-btn>
      <b-btn size="sm" variant="outline-danger">
        <font-awesome-icon @click="change(null)" class="px-2"
                           :icon="['fas', 'trash-can']"/>
      </b-btn>
    </b-btn-group>
    <b-form-file ref="label_file" @change="(file) => change(file)" v-else/>
  </div>
</template>

<style scoped>

</style>